<template>
    <!-- 树形组件 -->
    <el-tree
    :data="treeList"
    :show-checkbox="showCheckbox"
    :node-key="nodeKey"
    :default-expanded-keys="expandedKeys"
    :default-checked-keys="checkedKeys"
    :props="props" 
    :load="load"
    :lazy="lazy"
    :default-expand-all="expandAll"
    :highlight-current="highlightCurrent"
    :render-content="renderFn"
    :filter-node-method="filterFn"
    :accordion="accordion"
    :draggable="draggable"
    :render-after-expand="rednerAfterExpand"
    :expand-on-click-node="expandClickNode"
    :check-on-click-node="checkClickNode"
    :auto-expand-parent	="autoExpandParent"
    :check-strictly="checkStrictly"
    :indent="indent"
    :icon-class="iconClass"
    @node-drag-start="dragStart"
    @node-drag-enter="dragEnter"
    @node-drag-leave="dragLeave"
    @node-drag-over="dragOver"
    @node-drag-end="dragEnd"
    @node-drop="drop"
    :allow-drop="allowDrop"
    :allow-drag="allowDrag"
    @node-click="nodeClick"
    @check-change="checkChange"
    @check="check"
    >
        <!-- 插槽 -->
        <template slot-scope="item">
            <slot :item="item">
                {{item.node.label}}
            </slot>
        </template>
    </el-tree>
</template>
<script>
export default {
    name:"VelTree",
    props:{
        expandedKeys:Array,
        checkedKeys:Array,
        load:Function,
        renderFn:Function,
        filterFn:Function,
        allowDrop:Function,
        allowDrag:Function,
        indent:Number,
        iconClass:String,
        isShowCheckBox:Boolean,
        isLazy:Boolean,
        isExpandAll:Boolean,
        isHighlightCurrent:Boolean,
        isAccordion:Boolean,
        isDraggable:Boolean,
        isRednerAfterExpand:Boolean,
        isExpandClickNode:Boolean,
        isCheckClickNode:Boolean,
        isAutoExpandParent:Boolean,
        isCheckStrictly:Boolean,
        props:{
            type:Object,
            default:() =>{
                return {
                    children: 'children',
                    label: 'label'
                }
            }
        },
        nodeKey:{
            type:String,
            default:'id'
        },
        treeList:{
            type:Array,
            required:true,
        }
    },
    data() {
        return {
            showCheckbox:false,
            lazy:false,
            expandAll:false,
            highlightCurrent:false,
            accordion:false,
            draggable:false,
            rednerAfterExpand:true,
            expandClickNode:true,
            checkClickNode:false,
            autoExpandParent:true,
            checkStrictly:false,
        }
    },
    created() {
        this.initDataFn()
    },
    methods: {
        initDataFn(){ 
            this.isShowCheckBox ? this.showCheckbox = true : this.showCheckbox
            this.isLazy ? this.lazy = true : this.lazy
            this.isExpandAll ? this.expandAll = true : this.expandAll
            this.isHighlightCurrent ? this.highlightCurrent = true : this.highlightCurrent
            this.isAccordion ? this.accordion = true : this.accordion
            this.isDraggable ? this.draggable = true : this.draggable
            this.isRednerAfterExpand ? this.rednerAfterExpand = false : this.rednerAfterExpand
            this.isExpandClickNode ? this.expandClickNode = false : this.expandClickNode
            this.isCheckClickNode ? this.checkClickNode = true : this.checkClickNode
            this.isAutoExpandParent ? this.autoExpandParent = false : this.autoExpandParent
            this.isCheckStrictly ? this.checkStrictly = true : this.checkStrictly
        },
        nodeClick(data){
            this.$emit('nodeClick',data)
        },
        dragStart(node,e){
            this.$emit('dragStart',node,e)
        },
        dragEnter(node,allnode,e){
            this.$emit('dragEnter',node,allnode,e)
        },
        dragLeave(node,allnode,e){
            this.$emit('dragLeave',node,allnode,e)
        },
        dragOver(node,allnode,e){
            this.$emit('dragOver',node,allnode,e)
        },
        dragEnd(node,allnode,f,e){
            this.$emit('dragEnd',node,allnode,f,e)
        },
        drop(a,b,c,d){
            this.$emit('drop',a,b,c,d)
        },
        checkChange(a,b,c){
            this.$emit('checkChange',a,b,c)
        },
        check(a,b){
            this.$emit('check',a,b)
        }
    }
}
</script>